const KEY = "rightpay_offline_punches";

export function queuePunch(payload) {
  const q = JSON.parse(localStorage.getItem(KEY) || "[]");
  q.push({ ...payload, queued_at: Date.now() });
  localStorage.setItem(KEY, JSON.stringify(q));
}

export function getQueue() {
  return JSON.parse(localStorage.getItem(KEY) || "[]");
}

function setQueue(q) {
  localStorage.setItem(KEY, JSON.stringify(q));
}

export async function syncQueue(api) {
  const q = getQueue();
  if (!q.length) return 0;
  const remaining = [];
  let synced = 0;
  for (const p of q) {
    try {
      await api.post("/clock", { ...p, offline: true });
      synced += 1;
    } catch (err) {
      // network still down -> keep; auth/pin error -> drop to avoid infinite loop
      if (!err.response) remaining.push(p);
    }
  }
  setQueue(remaining);
  return synced;
}
